import React, { Component, createContext } from "react";
import { firestore } from "../firebase";
import Helper from "../components/helper";

export const PLANITEM_DELIVERY_CONTEXT = createContext();

class PlanItemDELIVERYProvider extends Component {
  state = { delivery_planItems: undefined };

  unsubscribe = null;

  subscribeToBranch = () => {
    this.unsubscribe = firestore.collection(Helper.getBranchCollectionName("containers", this.props.branchCode))
    .where("state", "==", "d")
    .onSnapshot(snapshot => {
      const containerObjs = snapshot.docs.map(doc => {
        return { id: doc.id, routingContainerState: "d", ...doc.data()};
      });

      let notInvoicedList = containerObjs.filter(function (obj) {
        return obj.invoiced !== true;
      });

      notInvoicedList.sort((a, b) => Helper.compareDateLike(a.pickUpDate, b.pickUpDate));

      this.setState({ delivery_planItems : notInvoicedList });
    });
  };

  componentDidMount = () => {
    this.subscribeToBranch();
  };

  componentDidUpdate = prevProps => {
    if ((prevProps.branchCode || "NY") !== (this.props.branchCode || "NY")) {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      this.setState({ delivery_planItems: undefined }, this.subscribeToBranch);
    }
  };

  componentWillUnmount = () => {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  };

  render() {
    const { delivery_planItems } = this.state;
    const { children } = this.props;

    return <PLANITEM_DELIVERY_CONTEXT.Provider value={delivery_planItems}>{children}</PLANITEM_DELIVERY_CONTEXT.Provider>;
  }
}

export default PlanItemDELIVERYProvider;

PlanItemDELIVERYProvider.defaultProps = {
  branchCode: "NY",
};
